import getIn from 'transmute/getIn';
import { FBM_AGENT_CONSENTED_AT, FBM_AGENT_DISMISSED_CONSENT_AT } from '../constants/keyPaths';
export const getFbmAgentConsentedAt = getIn(FBM_AGENT_CONSENTED_AT);
export const getFbmAgentDismissedConsentAt = getIn(FBM_AGENT_DISMISSED_CONSENT_AT);